module.exports = __webpack_public_path__ + "static/gifMeBlazer-58ad8f83fdc3ed4a426ebf71828bd34f.jpg";